import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Disconnect = ({
  color = colors.grey80,
  height = 24,
  isColorInherited = false,
  width = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <g
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.0858 7.79639L12.9835 6.92109L13.9779 5.92672C14.5074 5.35009 15.2432 5.00574 16.0252 4.9685C16.8072 4.93126 17.5723 5.20414 18.1542 5.72785C18.6775 6.30992 18.9501 7.07492 18.9128 7.85674C18.8754 8.63856 18.5312 9.37411 17.9548 9.90367L16.9605 10.898L16.0858 11.7964" />
      <path d="M7.67148 12.2109L6.79626 13.1085L5.80189 14.1029C5.22543 14.6326 4.88121 15.3682 4.84397 16.1502C4.80674 16.9322 5.0795 17.6972 5.60301 18.2793C6.18509 18.8025 6.95008 19.0751 7.73191 19.0378C8.51373 19.0004 9.24927 18.6562 9.77883 18.0798L10.7732 17.0855L11.6715 16.2108" />
      <path d="M17.6568 17.7817L6.34311 6.46802" />
    </g>
  </SvgIcon>
);
